import Vue from "vue";
import App from "./App.vue";
import axios from "axios";
import VueAxios from "vue-axios";

import { extend, localize } from "vee-validate";
import {
  min,
  required,
  email,
  min_value,
  max_value,
} from "vee-validate/dist/rules";
import de from "vee-validate/dist/locale/de.json";

// Install rules
extend("required", required);
extend("min", min);
extend("email", email);
extend("min_value", min_value);
extend("max_value", max_value);

extend("one_of", (value, values) => {
  return values.indexOf(value) !== -1;
});

// Install messages
localize("de", de);

Vue.config.productionTip = false;

// EUR Filter
Vue.filter("toEur", function(value) {
  return value !== 0 ? value.toFixed(2).replace(".", ",") + "€" : "inklusive";
});

// Datetime

import { Datetime } from "vue-datetime";
Vue.component("datetime", Datetime);

Vue.use(VueAxios, axios);

new Vue({
  render: (h) => h(App),
}).$mount("#app");
